import { useState } from 'react';
import Drawer from '@mui/material/Drawer';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import { IconButton } from '@mui/material';
import { Link } from 'react-router-dom';

const drawerLinks = [
    { to: "/overview", label: "Overview" },
    { to: "/dashboard", label: "Market Tracker" },
    { to: "/market-tracker-classic", label: "Markets" },
    { to: "/signal-center", label: "Signal Center" },
    { to: "/token-risk", label: "Token Risk" },
    { to: "/smart-money", label: "Wallets" },
    { to: "/auto-trading", label: "Auto Trading" },
    { to: "/anomaly", label: "Anomalies" },
    { to: "/graph", label: "Graph" },
    { to: "/signals", label: "Discovery" },
    { to: "/clusters", label: "Clusters" },
    { to: "/behavior-deep", label: "Behavior" },
    { to: "/event-flow", label: "Event Flow" },
    { to: "/pulse", label: "Network Pulse" },
    { to: "/raw", label: "Raw Data" },
    { to: "/feed", label: "Signals" },
];

export default function TemporaryDrawer() {
    const [open, setOpen] = useState(false);

    return (
        <div>
            <IconButton onClick={() => setOpen(true)}>
                <MenuRoundedIcon className='link' />
            </IconButton>
            <Drawer
                anchor={"right"}
                open={open}
                onClose={() => setOpen(false)}
                PaperProps={{ className: "drawer-paper" }}
            >
                <div className="drawer-div">
                    <p className="drawer-title">ChainIntel</p>
                    {drawerLinks.map((link) => (
                        <Link to={link.to} key={link.to} onClick={() => setOpen(false)}>
                            <p className="link">{link.label}</p>
                        </Link>
                    ))}
                </div>
            </Drawer>
        </div>
    );
}
